(function() {
  var btn = document.getElementById('ddsContactFabBtn');
  var container = document.getElementById('ddsContactFabContainer');
  if (!btn || !container) return;

  var iconChat = btn.querySelector('.icon-chat');
  var iconClose = btn.querySelector('.icon-close');
  var pulseInterval = null;

  // Verificăm dacă a fost deja afișat în această sesiune
  var shownBefore = sessionStorage.getItem('dds_contact_fab_shown');

  if (shownBefore === 'true') {
    // Afișare instantanee pe paginile următoare din sesiune
    container.classList.remove('fab-hidden-initial');
    startPulsing();
  } else {
    // Apariție cu delay de 3 secunde doar la prima accesare a site-ului
    setTimeout(function() {
      container.classList.remove('fab-hidden-initial');
      sessionStorage.setItem('dds_contact_fab_shown', 'true');
      startPulsing();
    }, 3000);
  }

  // 2. Funcție pentru pulsare la fiecare 15 secunde
  function startPulsing() {
    if (localStorage.getItem('dds_contact_fab_clicked') === 'true') {
      return;
    }
    
    pulseInterval = setInterval(function() {
      if (localStorage.getItem('dds_contact_fab_clicked') === 'true') {
        clearInterval(pulseInterval);
        return;
      }
      btn.classList.add('should-pulse');
      setTimeout(function() {
        btn.classList.remove('should-pulse');
      }, 2000);
    }, 15000);
  }

  function stopPulsing() {
    localStorage.setItem('dds_contact_fab_clicked', 'true');
    if (pulseInterval) {
      clearInterval(pulseInterval);
      pulseInterval = null;
    }
    btn.classList.remove('should-pulse');
  }

  btn.addEventListener('click', function() {
    stopPulsing();
    var isOpen = container.classList.contains('is-open');
    if (isOpen) {
      container.classList.remove('is-open');
      if (iconClose) iconClose.style.display = 'none';
      if (iconChat) iconChat.style.display = 'block';
    } else {
      container.classList.add('is-open');
      if (iconChat) iconChat.style.display = 'none';
      if (iconClose) iconClose.style.display = 'block';
    }
  });

  // Închidem meniul la click în afară
  document.addEventListener('click', function(event) {
    if (!container.contains(event.target) && container.classList.contains('is-open')) {
      container.classList.remove('is-open');
      if (iconClose) iconClose.style.display = 'none';
      if (iconChat) iconChat.style.display = 'block';
    }
  });

  // Oprire pulsare dacă apasă pe opțiuni
  var options = container.querySelectorAll('.dds-contact-option');
  options.forEach(function(opt) {
    opt.addEventListener('click', stopPulsing);
  });
})();
